export {registerIcons} from "./register_icons";
export * from './register_icons.module';
